import React from 'react';

import { secondsToTime } from 'Util/datetime';
import { useClassroomContext } from 'Context/ClassroomContext';

import { useAssessmentContext, SESSION_STATUS } from '../../../../../Context/AssessmentContext';

import ReviewAnswerView from './ReviewAnswer.view';

const ReviewAnswer = ({ history }) => {
  const {
    status,
    endSession,
    questions,
    setCurrentQuestionIndex,
    setStatus,
    timeRemaining: secondsRemaining,
  } = useAssessmentContext();
  const { layoutType } = useClassroomContext();
  const timeRemaining = secondsToTime(secondsRemaining);

  const handleSubmitSession = () => {
    endSession();
  };

  const handleEndQuiz = () => {
    history.push('/');
  };

  const handleBack = () => {
    setCurrentQuestionIndex(0);
    setStatus(SESSION_STATUS.IN_PROGRESS);
  };

  return (
    <ReviewAnswerView
      questions={questions}
      onBack={handleBack}
      onEndQuiz={handleEndQuiz}
      onSubmitSession={handleSubmitSession}
      timeRemaining={timeRemaining}
      isSubmitting={status === SESSION_STATUS.GRADE}
      isTimeout={status === SESSION_STATUS.TIMEOUT || status === SESSION_STATUS.READY_TO_GRADE}
      layoutType={layoutType}
    />
  );
};

export { ReviewAnswerView };
export default ReviewAnswer;
